import React from 'react';
import { Zap, Shield, Rocket, Target, Award, Clock } from 'lucide-react';

export const WhyChooseUs = () => {
  const reasons = [
    {
      icon: Zap,
      title: 'Lightning-Fast Delivery',
      description: 'Agile methodology meets cutting-edge tools. We deliver production-ready solutions 40% faster than industry average.'
    },
    {
      icon: Shield,
      title: 'Enterprise-Grade Security',
      description: 'Bank-level encryption, compliance-ready architecture, and proactive threat monitoring built into every project.'
    },
    {
      icon: Rocket,
      title: 'Scalable by Design',
      description: 'Future-proof solutions that grow with your business. From startup to enterprise, our architecture scales effortlessly.'
    },
    {
      icon: Target,
      title: 'Business-First Approach',
      description: 'Technology serves your goals, not the other way around. Every decision is driven by measurable business impact.'
    },
    {
      icon: Award,
      title: 'Proven Excellence',
      description: 'Award-winning team with a track record of transforming ambitious ideas into market-leading digital products.'
    },
    {
      icon: Clock,
      title: 'Transparent Process',
      description: 'Real-time project visibility, regular updates, and clear communication. You\'re never in the dark.'
    }
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-900/20 to-transparent"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 rounded-full glass mb-4">
            <span className="text-sm text-cyan-400 font-medium">Why GoAppward</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">
            The <span className="gradient-text">GoAppward</span> Advantage
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            We don't just build software. We engineer competitive advantages.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <div
                key={index}
                className="glass rounded-2xl p-8 hover:bg-slate-800/60 transition-all duration-300 group"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform">
                  <Icon className="w-7 h-7 text-cyan-400" />
                </div>
                
                <h3 className="text-xl font-bold mb-3 text-white">{reason.title}</h3>
                <p className="text-slate-400 leading-relaxed">{reason.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};